import styled from 'styled-components'

import NavLink from '../NavLink'
import { getColorLayers, TEMPLATE_BUTTONS, THEME } from '../../styles'
import SpinnerLoader from '../SpinnerLoader'

const Styled = {}
Styled.navLink = styled(NavLink)`
  ${({ size }) =>
    size === 'tiny'
      ? TEMPLATE_BUTTONS.buttonTiny
      : size === 'big'
        ? TEMPLATE_BUTTONS.buttonBig
        : TEMPLATE_BUTTONS.button};
  cursor: pointer;
  transition:
    background-color 0.2s ease-out,
    color 0.2s ease-in-out;

  &:disabled {
    color: ${THEME.COLORS.state.disabled.color};
    background: ${getColorLayers([
      THEME.COLORS.state.disabled.background,
      THEME.COLORS.background.secondary,
    ])};
    cursor: default;
  }
`
Styled.externalLink = styled.a`
  ${({ size }) =>
    size === 'tiny'
      ? TEMPLATE_BUTTONS.buttonTiny
      : size === 'big'
        ? TEMPLATE_BUTTONS.buttonBig
        : TEMPLATE_BUTTONS.button};
  cursor: pointer;
  transition:
    background-color 0.2s ease-out,
    color 0.2s ease-in-out;

  &:disabled {
    color: ${THEME.COLORS.state.disabled.color};
    background: ${getColorLayers([
      THEME.COLORS.state.disabled.background,
      THEME.COLORS.background.secondary,
    ])};
    cursor: default;
  }
`
Styled.button = styled.button`
  ${({ size }) =>
    size === 'tiny'
      ? TEMPLATE_BUTTONS.buttonTiny
      : size === 'big'
        ? TEMPLATE_BUTTONS.buttonBig
        : TEMPLATE_BUTTONS.button};
  cursor: pointer;
  transition:
    background-color 0.2s ease-out,
    color 0.2s ease-in-out;

  &:disabled {
    color: ${THEME.COLORS.state.disabled.color};
    background: ${getColorLayers([
      THEME.COLORS.state.disabled.background,
      THEME.COLORS.background.secondary,
    ])};
    cursor: default;
  }
`
Styled.loader = styled(SpinnerLoader)`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
`

export default Styled
